import React, { useEffect, useState } from 'react';
import { CardLayout, TableLayout } from '../../containers/Layout';
import { TableRow, TableCell, TableHead, TableBody, TableFooter, IconButton } from '@material-ui/core';
import SingleTransferTemplate from '../singleTemplates/SingleTransferTemplate';
import Currency from '../../../../../commonModules/Currency';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTransferDetails } from '../../../../../../../../jsx/actions/transferAction';
import { isEmpty } from 'lodash-es';
import { ArrowBack } from '@material-ui/icons';

const SingleTransferOccasionSale = (props) => {
    const dispatch = useDispatch();
	const PRODUCTS = useSelector((state) => state.inventory.products); 

    const [trsf, setTrsf] = useState({});
    // const [BL, setBL] = useState(false);
    // const [TVA, setTVA] = useState(true);

    useEffect(() => {
        const fetchTransferData = async () => {
            try {
                const data = await dispatch(fetchTransferDetails(props.transfer.id));
                setTrsf(data);
            } catch (error) {
                console.error('Error fetching transfer details:', error);
            }
        };
    
        fetchTransferData();
    }, [dispatch, props.transfer.id]);


    const createProductList = () => {
        // const { RETURNS } = props;

        return !isEmpty(trsf) && trsf.products.map((trsfItem) => {
            // let returnProd = RETURNS[trsfItem.return_product_id];
            let prod = PRODUCTS && PRODUCTS[trsfItem.product_id];
            const ssTt = parseFloat(trsfItem.total_ht); // prix vendu
            let PU = trsfItem.priceUReal || (ssTt /  trsfItem.quantity) ; // price real == return_product.sell_price
            let ssTtBase = parseFloat(PU * trsfItem.quantity); // prix base

            let discount = Math.round((1 - trsfItem.total_ht / (PU * trsfItem.quantity)) * 10000) / 100; // %
            let discountAmount = ssTt - ssTtBase;

            if (ssTt > ssTtBase) {
                ssTtBase = ssTt;
                PU = trsfItem.total_ht / trsfItem.quantity;
                discount = 0;
                discountAmount = 0;
            }

            return (
                <TableRow key={trsfItem.id || trsfItem.product_id}>
                    <TableCell className="text-left">{prod?.name || `Product ID: ${trsfItem.product_id}`}</TableCell>
                    <TableCell>{trsfItem.quantity}</TableCell>

                    <TableCell>{<Currency value={PU} />}</TableCell>
                    <TableCell>{<Currency value={ssTtBase} />}</TableCell>
                    <TableCell>{<Currency value={discountAmount} />}</TableCell>
                    <TableCell>{<Currency value={ssTt} />}</TableCell>
                </TableRow>
            );
        });
    };

    return (
        <CardLayout>
                <div >
                    <IconButton 
                        type="button" 
                        onClick={props.handleCloseSale}
                    > 
                        <ArrowBack />
                    </IconButton>
                </div>
        <SingleTransferTemplate
            shop={props.shop}
            client={props.client}
            transfer={trsf}
            notif={props.notif}
            occasion
            // handleBL={() => setBL(!BL)}
            // BL={BL}
            // BLOpt
            // TVA={TVA}
            // TVAOpt
            // handleCheck={() => setTVA(!TVA)}
        >
            <TableLayout>
                <TableHead>
                    <TableRow>
                        <TableCell className="text-left">Produit</TableCell>
                        <TableCell>Quantité</TableCell>
                        <TableCell>PU HT</TableCell>
                        <TableCell>Total HT</TableCell>
                        <TableCell>Remise</TableCell>
                        <TableCell>Total TTC</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>{createProductList()}</TableBody>
                <TableFooter>
                    <TableRow>
                        <TableCell colSpan={2}></TableCell>
                        <TableCell>TOTAL</TableCell>
                        <TableCell className="f-700">{/* {this.getTotal()[1]} */}</TableCell>
                        <TableCell className="f-700">{trsf.discount || 0}</TableCell>
                        <TableCell className="f-700">{trsf.total_price}</TableCell>
                    </TableRow>
                </TableFooter>
            </TableLayout>
        </SingleTransferTemplate>
        </CardLayout>
    );
};

export default SingleTransferOccasionSale;
